import { useSelector } from "react-redux";

import { resolveValueSignatureSelector } from "./valueSelectors.ts";

/**
 * Live signature resolution over designer state: an expression's form re-reads
 * its subject's type and subtype as the producing node's config changes.
 */
export const useResolveValueSignature = () => useSelector(resolveValueSignatureSelector);
